import { render, staticRenderFns } from "./productionCompany.vue?vue&type=template&id=627cce86&"
import script from "./productionCompany.vue?vue&type=script&lang=js&"
export * from "./productionCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports